<template>
	<section class="page page-home">
		<section class="content-container">
			<ViewFeedContainer />
		</section>

		<!-- PWA Notification -->
		<ViewLayoutPwaNotification v-if="!$store.getters['settings/pwaInstallStatus']" />
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageHome extends PageBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.page-home {
		// Not implemented
	}
</style>
